module.exports = __webpack_public_path__ + "2cc9a0cbb2a85802b0767ee94342bb38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/Beschäftigte.svg
// module id = 258
// module chunks = 1